<template>
  <!-- 弹窗 -->
  <el-dialog
    title="车辆称重"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="入场编号" prop="RegistrationNum">
            <div class="text">{{ form.RegistrationNum }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="车牌号" prop="LicensePlate">
            <div class="text">{{ form.LicensePlate }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="收车时间" prop="RegistrationDate">
            <div class="text">{{ form.RegistrationDate }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="毛重" prop="GrossWeight">
            <!-- <el-radio v-model="radio" label="1">毛重（kg）</el-radio> -->
            <el-input
              v-model="form.GrossWeight"
              placeholder="毛重（kg）"
              @change="CalculateWeigh"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="皮重" prop="TareWeight">
            <!-- <el-radio v-model="radio" label="2">皮重（kg）</el-radio> -->
            <el-input
              v-model="form.TareWeight"
              placeholder="皮重（kg）"
              @change="CalculateWeigh"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="净重" prop="CarWeigh">
            <!-- <el-radio v-model="radio" label="3">净重（kg）</el-radio> -->
            <el-input
              v-model="form.CarWeigh"
              placeholder="净重（kg）"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="text-align: center">
          <el-button
            type="warning"
            :loading="loading"
            @click="save"
            style="width: 300px; font-size: 16px"
            >获取地磅数据</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <!-- 按钮 -->
    <span slot="footer">
      <el-button type="primary" :loading="loading" @click="save"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      visible: false,
      loading: false,
      radio: "1",
      form: {},
      rules: {
        GrossWeight: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validNumber,
        ],
        TareWeight: [
          {
            required: true,
            message: "不可为空",
          },
          {
            validator: this.validTareWeight,
          },
          this.$g.validNumberAndZero,
        ],
        CarWeigh: [
          {
            required: true,
            message: "不可为空",
          },
          {
            validator: this.validcarWeight,
          },
          this.$g.validNumber,
        ],
      },
    };
  },
  watch: {
    item: {
      handler: function (v) {
        this.$get("VehicleRegistration/GetSettlementModel", {
          RegistId: v.KeyId,
        }).then((r) => {
          this.init({ ...r.Result });
        });
        this.activeNames = "1";
        this.visible = true;
      },
    },
  },
  // methods方法
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let params = { ...this.form };
        this.loading = true;
        this.$post("VehicleBusiness/AddWeight", params).then((r) => {
          this.$message.success("保存成功");
          this.visible = false;
          this.$emit("success");
        });
        this.loading = false;
      });
    },
    CalculateWeigh() {
      if (this.form.GrossWeight && this.form.TareWeight) {
        this.$set(
          this.form,
          "CarWeigh",
          parseFloat(this.form.GrossWeight) - parseFloat(this.form.TareWeight)
        );
      }
    },
    validTareWeight(rule, value, callback) {
      if (parseFloat(this.form.GrossWeight) <= parseFloat(value)) {
        callback(new Error("皮重不能大于毛重"));
      } else {
        callback();
      }
    },
    validcarWeight(rule, value, callback) {
      if (
        parseFloat(this.form.GrossWeight) - parseFloat(this.form.TareWeight) !=
        parseFloat(value)
      ) {
        callback(new Error("净重录入错误"));
      } else {
        callback();
      }
    },
  },
};
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
